<footer>
    <div style="margin-left: 60px;margin-right: 60px" >
        <span class="govco-co" ></span>
        <span class="govco-separator"></span>
        <span class="govco-logo"></span>
    </div>
</footer>
